import Link from "next/link"

import { Button } from "@coval/ui"
import { History, Link2, Pencil, TextCursorInput } from "lucide-react"

import { reportNotebookExport } from "../../utils/notebookExport"
import type { Notebook } from "../../utils/reportTypes"
import { NotebookDownloadButton } from "../NotebookDownloadButton"
import { reportClass } from "./ReportStyles"

export function ReportToolbarActions({
  notebook,
  organizationSlug,
  workspaceId,
  locked,
  dirty,
  editing,
  readonly,
  preview,
  sharingEnabled,
  onExporting,
  onHistory,
  onEdit,
  onRename,
  latestHref,
  onSave,
  onShare,
}: {
  notebook: Notebook
  organizationSlug: string
  workspaceId: string
  locked: boolean
  dirty: boolean
  editing: boolean
  readonly: boolean
  preview: boolean
  sharingEnabled: boolean
  onExporting: (busy: boolean) => void
  onHistory: () => void
  onEdit: () => void
  onRename: () => void
  /** On a read-only revision link, where the editable notebook lives. */
  latestHref?: string
  onSave: () => void
  onShare: () => void
}) {
  return (
    <div className={reportClass("toolbar-actions")}>
      <NotebookDownloadButton
        key={`${organizationSlug}:${workspaceId}:${notebook.id}`}
        notebook={reportNotebookExport(notebook)}
        organizationSlug={organizationSlug}
        workspaceId={workspaceId}
        disabled={locked || dirty || editing}
        onBusyChange={onExporting}
      />
      {latestHref && (
        <Button asChild variant="secondary">
          <Link href={latestHref}>
            <Pencil />
            Open notebook
          </Link>
        </Button>
      )}
      {!readonly && (
        <>
          <Button variant="ghost" disabled={locked} onClick={onHistory}>
            <History />
            History
          </Button>
          {!preview && !editing && !dirty && (
            <Button variant="ghost" disabled={locked} onClick={onRename}>
              <TextCursorInput />
              Rename
            </Button>
          )}
          {!preview && (
            <Button variant="secondary" disabled={locked} onClick={onEdit}>
              <Pencil />
              {editing ? "Preview" : "Edit"}
            </Button>
          )}
          {dirty && (
            <Button disabled={locked} onClick={onSave}>
              Save revision
            </Button>
          )}
          {sharingEnabled && (
            <Button variant="secondary" disabled={locked} onClick={onShare}>
              <Link2 />
              Copy revision link
            </Button>
          )}
        </>
      )}
    </div>
  )
}
